import { useLocation } from 'react-router-dom';
import { useConciergeState } from '../../../recoil/concierge';
import { useInterphoneState } from '../../../recoil/interphone';
import { useRecoilValue } from 'recoil';
import { fcmConciergeCountState, fcmSalesCountState } from '../../../recoil/fcmMessage';

export const useMobileFooter = () => {
  const location = useLocation();

  const useConcierge = useRecoilValue<boolean>(useConciergeState);
  const useInterphone = useRecoilValue<boolean>(useInterphoneState);
  const fcmConciergeCount = useRecoilValue(fcmConciergeCountState);
  const fcmSalesCount = useRecoilValue(fcmSalesCountState);

  return {
    location,
    useConcierge,
    useInterphone,
    fcmConciergeCount,
    fcmSalesCount,
  };
};
